var cannotLoadAjax = "Can not process your request";
var makeText = 'Make';

 function toUpperCase(id) {
      $("#" + id).val($("#" + id).val().toUpperCase().replace(/Q/g, "0").replace(/O/g, "0").replace(/I/g, "1").replace(/[^a-zA-Z0-9]/g, ''));//.replace(/L/g, "1"));
  }
  function typingEventCode(e){
    var code = e.keyCode || e.which; 
    if ((code != 8 && code != 13) && (code < 48 || code > 57) && (code < 65 || code > 90) && (code < 97 || code > 122)){
       return false;
     }  
  }

  function getMakes() {    
    var url = "/apps/innova-api/dtc/makes/?r=" + Math.random();
	
    $.ajax({
      type: "GET",    
      url: url,      
      error: function () {
        alert(cannotLoadAjax);
      },
      success: function (data) {
        var result = data.makes;
        var options = "<option value=''>" + makeText + "</option>";
        for (var i = 0; i < result.length; i++) {
          options += '<option value="' + result[i] + '">' + result[i] + '</option>';
        }
        $("select#make").html(options);      
      }
    });
  }

  function getDtcDefinition() {
	$("#errorMessage").hide();
   	var sVin = $("#vin").val();
    var sMake = $("#make").val();
    
    if(!checkRequiredFields('frmDtc')){
        return false;
      }
    
      
	  $('#ModalContentAjax').modal("show");
	  var url = "/apps/innova-api/dtc/definition/?r=" + Math.random();	  
	  $.ajax({
        type: "POST",       
        url: url,
        data: $("#frmDtc").serialize(),        
        error: function () {
			$('#ModalContentAjax').modal("hide");
          	grecaptcha.reset(0);
            alert(cannotLoadAjax);
        },
        success: function (data) {          	       
    		$("#codeContent").text(data.errorCode);
            $("#makeContent").text(data.make);
            $("#descContent").text(data.definition);
          
          	$('#ModalContentAjax').modal("hide");  
          	grecaptcha.reset(0);
            $("#captcharDiv").hide();
        }
	  });	  
  }

document.addEventListener('DOMContentLoaded', function() {   
	getMakes();   
  
    $('#frmDtc').on('submit', function(e){
      e.preventDefault();
    });

    $('#dtc').keypress(function (event) {
        return typingEventCode(event);
    });
  
    $('#dtc').keydown(function (event) {
      if (event.keyCode == 13) {
        getDtcDefinition();          
      }

    });

    $('#dtc').keyup(function (event) {
      toUpperCase('dtc');
    });
  
    var captchaKey = $("#GoogleCaptchaKey").val();
    $("div.g-recaptcha").attr("data-sitekey", captchaKey);  
  
  	$("#captcharDiv").hide();    
    
    $("#searchDtcBtn").click(function(){     
    	var numberOfClicksCookie = getCookie("dtc-search-times");
        var numberOfClicks =  numberOfClicksCookie != undefined && numberOfClicksCookie != null ? JSON.parse(numberOfClicksCookie) : [];    
    	
        if(numberOfClicks.length < queryCount){
           numberOfClicks.push(new Date().getTime());
           setCookie("dtc-search-times", JSON.stringify(numberOfClicks), 0);
           getDtcDefinition();
        }else{ 
          var diff = numberOfClicks[numberOfClicks.length -1] - numberOfClicks[0];            
          if(diff < captInMiliSecond){ 
              $('#re-captcha').show();             
			  grecaptcha.reset(0);              
              $("#captcharDiv").show();              
            }else{
            	numberOfClicks.shift();
            	numberOfClicks.push(new Date().getTime());                 
                setCookie("dtc-search-times", JSON.stringify(numberOfClicks), 0);
               
              	getDtcDefinition();
             }
        }
    });
    
  
});

var actCallback = function (response) {
  getDtcDefinition();
  //$("#captchaText").val("1");
  //$('#re-captcha').remove();
  $("#captcharDiv").hide();

};
var expCallback = function() {
  //$("#captchaText").val("0");
  grecaptcha.reset(0);
  setTimeout(function(){
    grecaptcha.reset(0);
  }, 30000);
};

var onloadCallback = function () {
  var captchaKey = $("#GoogleCaptchaKey").val();
  var widget = grecaptcha.render(document.getElementById("re-captcha"), {
    'sitekey' : captchaKey, // Sitekey, Retrieving from reCaptcha
    'theme': "light",
    'callback' : actCallback,
    'expired-callback': expCallback,
  });
}

